import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import theme from '../../../../theme';
import { Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { ServiceValues } from '../../../../values/ServiceValues';
import { ServiceAxios } from '../../../../services/ServiceEW';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import IconButton from '@material-ui/core/IconButton';
import TablePagination from '@material-ui/core/TablePagination';
import DeleteIcon from '@material-ui/icons/Delete';



const useStyles = makeStyles({
  root: {},
  row: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  tableWrapper: {
    maxHeight: 300,
    overflow: 'auto',
  },

  autoCompleteStyle: {
  }
});

export default function EmpresaRegisterUsers(props) {
  const baseUrl = ServiceValues.base_url_local;
  const timeout = ServiceValues.timeout;
  const api = ServiceAxios(baseUrl, timeout);
  const classes = useStyles();
  const { className, history, empresa, setEmpresa, edicao,...rest } = props;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [usuariosVinculados, setUsuariosVinculados] = useState([]);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState({});
  const [empresaLocal, setEmpresaLocal] = useState(props.empresa);
  const [refreshState, setRefreshState] = useState('');
  const [openAutocomplete, setOpenAutocomplete] = useState(false);
  const [users, setUsers] = useState([]);
  const loadingUsers = openAutocomplete && users.length === 0;

  function sleep(delay = 0) {
    return new Promise(resolve => {
      setTimeout(resolve, delay);
    });
  }

  useEffect(() => {
    let active = true;

    if (!loadingUsers) {
      return undefined;
    }

    (async () => {
      const params = {
        limit: 5000,
      };
      let dados = await api.get('usuarios/', {params: params});
      dados = dados.data.result;

      if (active) {
        setUsers(dados);

      }
    })();

    return () => {
      active = false;
    };
  }, [loadingUsers]);

  React.useEffect(() => {
    if (!openAutocomplete) {
      setUsers([]);
    }
  }, [openAutocomplete]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function aoModificarUsuario(event, usuario) {
    if(usuario !== undefined){
      setUsuarioSelecionado(usuario);
    }

  }

  function adicionarUsuario() {
    if(usuarioSelecionado !== undefined){
      empresa.usuarios.push(usuarioSelecionado);
      setEmpresa(empresa);
      setUsuarioSelecionado(undefined);
    }
  }

  function removerUsuario(event, index) {
    if(edicao){
      empresa.usuarios[index].idUsuario = undefined;
      setEmpresa(empresa);
      setRefreshState(new Date());
    }
    else{
      empresa.usuarios.splice(index, 1);
      setEmpresa(empresa);
      setRefreshState((new Date).toString());
    }

  }


  return (
    <div>
      <ValidatorForm
        autoComplete="off"
        onSubmit={adicionarUsuario}
      >
        <CardHeader
          subheader="Informe os seguintes dados para adicionar um endereço"
          title="Endereços"
        />
        <CardContent>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={9}
              xs={12}
            >
              <Autocomplete
                size={'small'}
                id="autocomplete_usuario"
                open={openAutocomplete}
                value={usuarioSelecionado}
                onOpen={() => {
                  setOpenAutocomplete(true);
                }}
                onClose={() => {
                  setOpenAutocomplete(false);
                }}
                onChange={aoModificarUsuario}
                getOptionSelected={(option, value) => option.nome === option.nome}
                getOptionLabel={option => option.nome}
                options={users}
                loading={loadingUsers}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Usuários"
                    fullWidth
                    value={usuarioSelecionado}
                    variant="outlined"
                    helperText={'Selecione um usuário no qual deseja conceder acesso a essa empresa e clique no botão adicionar.'}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {loadingUsers ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
            >
              <Button
                color="primary"
                fullWidth
                size="large"
                type="submit"
                variant="contained"
              >
                Adicionar
              </Button>
            </Grid>

              <Grid
                item
                md={12}
                xs={12}
              >
                <Paper className={classes.root}>
                  <div className={classes.tableWrapper}>

                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Nome</TableCell>
                          <TableCell>CPF/CNPJ</TableCell>
                          <TableCell>Ações</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {empresa.usuarios.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((usuario, index) => {
                          return (
                            usuario.idUsuario &&
                            <TableRow hover role="checkbox" tabIndex={-1} key={usuario.idUsuario}>
                              <TableCell>{usuario.nome}</TableCell>
                              <TableCell>{usuario.cpfCnpj}</TableCell>
                              <TableCell>
                                <IconButton
                                  aria-label="delete"
                                  className={classes.expand}
                                  onClick={e => removerUsuario(e, index)}

                                >
                                  <DeleteIcon
                                    fontSize={'small'}
                                    color={'action'}
                                  />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                  <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={empresa.usuarios.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                      'aria-label': 'previous page',
                    }}
                    nextIconButtonProps={{
                      'aria-label': 'next page',
                    }}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                  />
                </Paper>
              </Grid>
          </Grid>
        </CardContent>

      </ValidatorForm>
    </div>
  );
}
